var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "copy.1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Black-Theme",
    transform: "translate(-450.000000, -142.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19",
    transform: "translate(16.000000, 138.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "copy.1",
    transform: "translate(434.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.78,21.49 L3.44,21.49 C1.9985368,21.49 0.83,20.3214632 0.83,18.88 L0.83,5.9 C0.83,5.20870101 1.10529496,4.54586085 1.5950545,4.05797778 C2.08481403,3.57009472 2.74870613,3.29734116 3.44,3.29998074 L11.78,3.29998074 C12.4712939,3.29734116 13.135186,3.57009472 13.6249455,4.05797778 C14.114705,4.54586085 14.39,5.20870101 14.39,5.9 L14.39,18.9 C14.3790139,20.3336466 13.2136887,21.49 11.78,21.49 Z M3.44,4.8 C2.83084803,4.8 2.33548786,5.29087275 2.33,5.9 L2.33,18.9 C2.33548786,19.5091272 2.83084803,20 3.44,20 L11.78,20 C12.3930361,20 12.89,19.5030361 12.89,18.89 L12.89,5.9 C12.8845121,5.29087275 12.389152,4.8 11.78,4.8 L3.44,4.8 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.42,16.85 C16.0057864,16.85 15.67,16.5142136 15.67,16.1 L15.67,5.65 C15.6700146,4.67848461 15.2827179,3.74704898 14.5938784,3.06196337 C13.9050389,2.37687775 12.9715008,1.99467663 12,2 L6.22,2 C5.80578644,2 5.47000001,1.66421356 5.47000001,1.25 C5.47000001,0.835786442 5.80578644,0.5 6.22,0.5 L12,0.5 C14.8364613,0.505502365 17.1344976,2.80353867 17.14,5.64 L17.14,16.1 C17.1352808,16.5007308 16.8202046,16.8289352 16.42,16.85 L16.42,16.85 Z",
    id: "Path"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.1d647225.svg";
export { ForwardRef as ReactComponent };